import { ApolloError, useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { Organization } from "@/types/Organization";
import { ORGANIZATION_DETAILS } from "@/api/queries/orgDetails";

export const useOrgDetails = (): {
  org: Organization | undefined;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const { orgId } = useParams<{ orgId: string | undefined }>();
  const { data, loading, error } = useQuery(ORGANIZATION_DETAILS, {
    variables: { id: orgId ?? "" },
    skip: !orgId,
  });

  const org = data?.node?.__typename === "Organization" ? data.node : undefined;

  return {
    org,
    loading: loading,
    error: error,
  };
};
